export class StatementM{
  no:string = '';
  user_id:number = 0;
  debit:number = 0;
  credit:number = 0;
  balance:number = 0;
  detail:string = '';
  status:string = '';
  created_at:string = '';
  updated_at:string = '';
  ref_order_id:number = 0;
  bank_id:number = 0;
  return_back:Boolean = false;
  transferred_ref_no:string = '';
  selected:Boolean = false
}



// WEBPACK FOOTER //
// ./src/app/model/statement.ts